import React, { useMemo, useState } from "react";
import { Box, Button, Popover, Stack, Typography } from "@mui/material";
import Fab from "@mui/material/Fab";
import TelegramIcon from "@mui/icons-material/Telegram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneIcon from "@mui/icons-material/Phone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { BRANDING } from "../config/branding";

const defaultMessage = "Hola, quiero información. Vengo desde el chat de Telegram.";

const getTelegramUrl = () => {
  const username = String(BRANDING.telegramBotUsername || "").trim().replace(/^@/, "");
  if (!username) return "";
  return `https://t.me/${username}`;
};

const FloatingTelegramButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const telegramUrl = useMemo(() => getTelegramUrl(), []);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleTelegramClick = () => {
    if (!telegramUrl) return;
    window.open(telegramUrl, "_blank");
    handleClose();
  };

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${BRANDING.whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`;
    window.open(url, "_blank");
    handleClose();
  };

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: (theme) => theme.zIndex.modal + 1,
        }}
      >
        <Fab
          aria-label="chat telegram"
          onClick={handleOpen}
          sx={{
            width: 56,
            height: 56,
            color: "white",
            background: "linear-gradient(135deg, #1d9bf0 0%, #1976d2 55%, #0d47a1 100%)",
            boxShadow: 5,
            "&:hover": {
              background: "linear-gradient(135deg, #1d9bf0 0%, #1565c0 55%, #0b3d91 100%)",
            },
          }}
        >
          <TelegramIcon />
        </Fab>
      </Box>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
        PaperProps={{
          sx: {
            width: 340,
            p: 3,
            borderRadius: 3,
          },
        }}
      >
        <Stack spacing={1.5}>
          <Typography variant="subtitle1" fontWeight={700}>
            Chat y contacto
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {BRANDING.hoursText
              ? `Horario de atención: ${BRANDING.hoursText}.`
              : "Elige el canal de contacto que prefieras."}
          </Typography>

          <Stack spacing={1}>
            <Button
              variant="contained"
              onClick={handleTelegramClick}
              startIcon={<TelegramIcon />}
              sx={{ borderRadius: 999 }}
              disabled={!telegramUrl}
            >
              Chat en Telegram
            </Button>

            <Button
              variant="contained"
              color="success"
              onClick={handleWhatsAppClick}
              startIcon={<WhatsAppIcon />}
              sx={{ borderRadius: 999 }}
            >
              Hablar por WhatsApp
            </Button>

            <Button
              variant="outlined"
              startIcon={<PhoneIcon />}
              component="a"
              href={`tel:${BRANDING.telHref}`}
              sx={{ borderRadius: 999 }}
            >
              Llamar ahora
            </Button>

            <Button
              color="secondary"
              startIcon={<MailOutlineIcon />}
              component="a"
              href={`mailto:${BRANDING.companyEmail}`}
              sx={{ borderRadius: 999 }}
            >
              Enviar correo
            </Button>
          </Stack>
        </Stack>
      </Popover>
    </>
  );
};

export default FloatingTelegramButton;

